<template lang="pug">
div.field
	template(v-if="name")
		Field(v-if="useInt" type="checkbox" :name="name" v-model="value" :value="1" :unchecked-value="0" @change="fieldUpdated" :disabled="disabled" :class="{'reverse':reverse}")
		Field(v-else type="checkbox" :name="name" v-model="value" :value="true" :unchecked-value="false" @change="fieldUpdated" :disabled="disabled" :class="{'reverse':reverse}")
	//- fallback...
	template(v-else)
		input(v-if="useInt" type="checkbox" v-model="value" true-value="1" false-value="0" @change="fieldUpdated" :disabled="disabled" :class="{'reverse':reverse}")
		input(v-else type="checkbox" v-model="value" :true-value="true" :false-value="false" @change="fieldUpdated" :disabled="disabled" :class="{'reverse':reverse}")
	label {{label}}
	span.on(v-if="value") {{yesLabel}}
	span.off(v-else) {{noLabel}}
</template>

<script>
import { Field } from 'vee-validate';

export default {
	name: 'FieldBoolean2',
	props: {
		modelValue: {
			validator(value) {
				return (value === 0 || value === 1 || typeof value === 'boolean');
			},
			default: false,
		},
		name: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: 'Boolean',
		},
		yesLabel: {
			type: String,
			default: 'Yes',
		},
		noLabel: {
			type: String,
			default: 'No',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		reverse: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['fieldUpdated','update:modelValue'],
	components: {
		Field,
	},
	data() {
		return {
			useInt: false,
		}
	},
	mounted() {
		this.useInt = (typeof this.value !== 'boolean');
	},
	computed: {
		trueValue() {
			return this.useInt ? '1' : true;
		},
		falseValue() {
			return this.useInt ? '0' : false;
		},
		value: {
			get() {
				return this.modelValue;
			},
			set(value) {
				this.$emit('update:modelValue', this.useInt ? parseInt(value) : value);
			}
		},
	},
	methods: {
		fieldUpdated() {
			this.$emit('fieldUpdated');
		},
	},
}
</script>

<style lang="scss">
</style>
